var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1583 3.84766H3.93099C2.97133 3.84766 2.19189 4.6271 2.19189 5.58675V20.2609C2.19189 21.2206 2.97133 22 3.93099 22H14.1583C15.118 22 15.8974 21.2206 15.8974 20.2609V5.58675C15.8929 4.6271 15.1135 3.84766 14.1583 3.84766ZM14.6764 20.2564C14.6764 20.5448 14.4422 20.7791 14.1538 20.7791H3.92648C3.63814 20.7791 3.40385 20.5448 3.40385 20.2564V5.58675C3.40385 5.2984 3.63814 5.06412 3.92648 5.06412H14.1538C14.4422 5.06412 14.6764 5.2984 14.6764 5.58675V20.2564Z",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.069 0H7.84163C6.88198 0 6.10254 0.779439 6.10254 1.73909C6.10254 2.077 6.37286 2.34733 6.71077 2.34733C7.04868 2.34733 7.319 2.077 7.319 1.73909C7.319 1.45075 7.55329 1.21647 7.84163 1.21647H18.069C18.3573 1.21647 18.5916 1.45075 18.5916 1.73909V16.4133C18.5916 16.7016 18.3573 16.9359 18.069 16.9359C17.731 16.9359 17.4607 17.2062 17.4607 17.5441C17.4607 17.882 17.731 18.1524 18.069 18.1524C19.0286 18.1524 19.808 17.3729 19.808 16.4133V1.73909C19.808 0.779439 19.0286 0 18.069 0Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4f00c4ea8406c876d91eea345cfa1764.svg";
export { ForwardRef as ReactComponent };